export default __webpack_public_path__ + "static/media/cloud.b89facab.svg";